const distortionBar = (num) => {
  const jsMainImgBars = (document.getElementById("jsMainImgBars") != null);
  if (jsMainImgBars) {


    let jsMainImgBars = document.getElementById('jsMainImgBars');
    let jsBar = jsMainImgBars.querySelectorAll('.js-bar');

    if (num == 0) {
      for (let i = 0; i < jsBar.length; i++) {
        jsBar[i].classList.remove('act')
      }
    }
    setTimeout(() => {
      jsBar[num].classList.add('act')
    }, 100)


  }
};
export default distortionBar;